
export const gestaoPessoaRouter = [{
  path: "/" + process.env.VUE_APP_BASE_URL + "/parametrizacoes",
  component: () => import("@/template/WrapperRouter.vue"),
  children: [
    {
      path: "consultaCadastro",
      name: "GESTAOPESSOA_MENU",
      component: () => import("@/paginas/parametrizacoes/consultaCadastro.vue"),
      meta: {
        auth: ['GESTAOPESSOA_MENU'],
      }
    },
    {
      path: "resetCadastro",
      name: "RESET_CADASTRO",
      component: () => import("@/paginas/parametrizacoes/resetCadastro.vue"),
      meta: {
        auth: ['GESTAOPESSOA_MENU', 'RESET_CADASTRO'],
      }
    },
    {
      path: "auditoria",
      name: "GESTAOPESSOA_AUDITORIA_VIEW",
      component: () => import("@/paginas/parametrizacoes/auditoria.vue"),
      meta: {
        auth: ['GESTAOPESSOA_MENU', 'GESTAOPESSOA_AUDITORIA_VIEW'],
      }
    },
    {
      path: "novoEmpregado",
      name: "empregado-container",
      component: () => import("@/paginas/seguranca/usuario/ContainerEmpregado.vue"),
      meta: {
        auth: ['GESTAOPESSOA_MENU'],
      }
    },
    {
      path: "basesExternas",
      name: "GESTAOPESSOA_IMPORTE_BASE_EXTERNA_VIEW",
      component: () => import("@/paginas/parametrizacoes/tabPanelBasesExternas.vue"),
      meta: {
        auth: ['GESTAOPESSOA_MENU', 'GESTAOPESSOA_IMPORTE_BASE_EXTERNA_VIEW'],
      }
    },
    {
      path: "cadastroChefia",
      name: "GESTAOPESSOA_CADASTRO_CHEFIA_VIEW",
      component: () => import("@/paginas/parametrizacoes/cadastroChefia.vue"),
      meta: {
        auth: ['GESTAOPESSOA_MENU', 'GESTAOPESSOA_CADASTRO_CHEFIA_VIEW'],
      }
    },
    {
      path: "permissoes",
      name: "GESTAOPESSOA_PERMISSOES_VIEW",
      component: () => import("@/paginas/parametrizacoes/permissoesGestaoPessoas.vue"),
      meta: {
        auth: ['GESTAOPESSOA_MENU', 'GESTAOPESSOA_PERMISSOES_VIEW'],
      }
    },
    {
      path: "cadastroUECMP",
      name: "GESTAOPESSOA_CADASTRO_UECMP_VIEW",
      component: () => import("@/paginas/parametrizacoes/cadastroUECMP.vue"),
      meta: {
        auth: ['GESTAOPESSOA_MENU', 'GESTAOPESSOA_CADASTRO_UECMP_VIEW'],
      }
    },
    {
      path: "orgaosVinculados",
      name: "GESTAOPESSOA_ORGAOS_VINCULADOS_VIEW",
      component: () => import("@/paginas/parametrizacoes/orgaosVinculados.vue"),
      meta: {
        auth: ['GESTAOPESSOA_MENU', 'GESTAOPESSOA_ORGAOS_VINCULADOS_VIEW'],
      }
    },
  ],
}]